import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { IonButton } from '@ionic/angular';

@Component({
  selector: 'bepatient-onboarding-button',
  templateUrl: './onboarding-button.component.html',
  styleUrls: ['./onboarding-button.component.scss'],
  standalone: false
})
export class OnboardingButtonComponent {
  @Input() disabled: boolean;
  @Input() isInstanceColor: boolean = false;

  @Output() buttonClick = new EventEmitter<MouseEvent>();

  @ViewChild(IonButton, { read: ElementRef, static: true })
  buttonElement: ElementRef;

  @Input() set color(v: string) {
    this.applyColor(v);
  }

  private applyColor(color: string): void {
    const style =
      this.buttonElement &&
      this.buttonElement.nativeElement &&
      this.buttonElement.nativeElement.style;
    if (style) {
      style.setProperty('--background', color);
      style.setProperty('--background-focused', color);
      style.setProperty('--background-activated', color);
    }
  }
}
